import { useAgentOutputKind } from '@/hooks/useAgentOutputKind'
import type { AgentOutputProps } from './types'
import { pickRenderer } from './registry'

/**
 * Dispatcher: given an agent + its execution result, picks the correct
 * per-agent renderer from the registry. While the output_kind is resolving
 * (first load of an agent), shows the JSON fallback so the user still sees
 * something useful.
 */
export default function OutputRenderer(props: AgentOutputProps) {
  const kind = useAgentOutputKind(props.agent?.name)
  const Comp = pickRenderer(kind)
  return <Comp {...props} />
}
